export default object => ({
  id: object.id,
  type: object.type,
  number: object.number,
  year: object.year,
  date: new Date(),
  note: null,
});
